"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactScroll = require("react-scroll");

var _reactFeather = require("react-feather");

var _jsFileDownload = _interopRequireDefault(require("js-file-download"));

var _export = require("../../lib/utils/helper/export");

var _components = require("../../components");

var _Global = require("../../styles/Global.style");

var BodySection = function BodySection(_ref) {
  var section = _ref.section,
      setRowsToExport = _ref.setRowsToExport,
      resetRows = _ref.resetRows,
      currentDocument = _ref.currentDocument,
      rawDocument = _ref.rawDocument;

  var downloadSection = function downloadSection(document, title) {
    var exportedSectionString;
    exportedSectionString = (0, _export.exportSection)(rawDocument, title);
    var patientName = currentDocument.header['Patient Name'];
    var fileName = "".concat(patientName, "_") + title.split(' ').join('_');
    var blob = new Blob([exportedSectionString], {
      type: 'text/xml'
    });
    (0, _jsFileDownload.default)(blob, "".concat(fileName, ".xml"));
  };

  return /*#__PURE__*/_react.default.createElement(_reactScroll.Element, {
    name: section.title
  }, /*#__PURE__*/_react.default.createElement(_Global.Section, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "section-title"
  }, /*#__PURE__*/_react.default.createElement("h4", null, section.title), /*#__PURE__*/_react.default.createElement(_components.Button, {
    text: "Export ".concat(section.title),
    icon: /*#__PURE__*/_react.default.createElement(_reactFeather.Download, null),
    className: "flex grey small",
    onClick: function onClick() {
      return downloadSection(rawDocument, section.title);
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "section-body"
  }, section ? section.data.map(function (el, key) {
    if (el.type === 'raw' || el.type === 'paragraph' || el.type === 'caption' || el.type === 'footnote' || el.type === 'list') {
      return /*#__PURE__*/_react.default.createElement(_components.Text, {
        key: "text".concat(key)
      }, el.content);
    } else if (el.type === 'table' && el.content && el.content.data && el.content.data.length) {
      return /*#__PURE__*/_react.default.createElement(_components.TableV2, {
        key: "table".concat(key),
        columns: el.content.columns,
        data: el.content.data,
        sectionTitle: section.title,
        setRowsToExport: setRowsToExport,
        resetRows: resetRows
      });
    }
  }) : null)));
};

var _default = BodySection;
exports.default = _default;